import Search from "views/logic/search/Search";
import fetchSearch from "views/logic/views/fetchSearch";
import View from "./View";
export default function ViewDeserializer(viewResponse) {
  const view = View.fromJSON(viewResponse);
  return fetchSearch(viewResponse.search_id).then((search) => Search.fromJSON(search)).then((search) => view.toBuilder().search(search).build());
}
